export enum EpisodeGesetzlichScheinart {
  AMBULANT = '0101',
  UEBERWEISUNG = '0102',
  BELEGAERZTLICH = '0103',
  NOTFALL = '0104',
}
